import { action, asyncAction } from 'now-frontend-shared/utils/actions';

// async actions
export const getPropertiesMarkers = asyncAction('map/GET_PROPERTIES_MARKERS');
export const getHistoricalListings = asyncAction('map/GET_HISTORICAL_LISTINGS');

// sync actions
export const clearState = action('map/CLEAR_STATE');
